/**
 * =============================================================================
 * api-geoapify.js 
 * =============================================================================
 * Get geographic data about the user using Geoapify
 * =============================================================================
 */

var APIGeoapify = {

  // Geoapify API key - public, should be domain-limited within Geoapify
  api_key: null,

  onReady: function(){
    this.getUserGeoData().then(function(result) {
      let geodataJSON = JSON.parse(result);
      if(geodataJSON.error){
        console.warn("[A-G] Error getting location");
        return;
      }

      // Dispatch a CustomEvent for other extensions to listen for / react to
      let event = new CustomEvent("geodata:loaded", {
        detail: {
          data: geodataJSON
        }
      });
      document.dispatchEvent(event);
    }).catch(e => {
      console.warn(e);
    });
  },

  /**
   * Get either cached or fresh geolocation data. If not cached, store as cookie
   * 
   * @returns {Promise} a Promise
   */
  getUserGeoData: function() {
    if(Cookies.get('mp-geo') === undefined) {
      return this.fetchUserGeoData();
    } else {
      return Promise.resolve(Cookies.get("mp-geo"));
    }
  },

  /**
   * Get the current user's geographic data from their IP via Geoapify
   * 
   * @returns {Promise} a Promise
   */
  fetchUserGeoData: function() {
    let requestOptions = {
      method: 'GET',
    };

    if(!this.api_key){
      throw new Error("[A-G] No API key specified");
    }
    
    return fetch("https://api.geoapify.com/v1/ipinfo?&apiKey=" + this.api_key, requestOptions)
      .then(function(response) {
        return response.json();
      })
      .then(function(result) {
        Cookies.set("mp-geo", JSON.stringify(result));
        return JSON.stringify(result);
      })
      .catch(function(error) {
        console.error('[A-G] Error fetching geo data', error);
      });
  }
};

export default APIGeoapify;